<template>
  <div>   
    <v-container grid-list-xl> 
        <v-layout align-center="" justify-center="">
            <v-col sm="12" cols="12">
                <br>
                <v-card > 
                    <not-cpanel-tab 
                        :not_show="true"
                        :not="not" /> 
                    <v-card-title class="primary white--text" >
                        <div class="not-f7 font-italic ">
                              {{visitersSize}} people visited
                        </div>
                    </v-card-title> 
                        
                    <v-card v-if="!page_show" 
                        :height="vsh/2"
                        tile="">
                        <not-page-spinner :not_show="true" /> 
                    </v-card>
                    <div v-else>
                        
                        <v-card-text class="primary lighten-5 pa-5" v-if="visiters">
                            <v-card>
                                <v-toolbar color="primary">
                                    <v-spacer></v-spacer>
                                    <v-menu  bottom left 
                                        v-model="menuTableSet"
                                        :close-on-content-click="false"
                                        :nudge-width="250">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                dark outlined="" rounded=""
                                                icon
                                                v-on="on" >
                                                <v-icon>mdi-tune</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-card>
                                            <v-card-title primary-title>
                                                <v-layout >
                                                    CUSTOMIZE TABLE
                                                    <v-spacer></v-spacer>
                                                    <v-btn icon="" @click="menuTableSet=false"><v-icon>close</v-icon></v-btn>
                                                </v-layout>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-list subheader="" dense="">
                                                    <div v-for="(item, i) in xHeaders" :key="i">
                                                        <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                                        <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeaders,i)" >
                                                            <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                                            <v-list-item-title>{{item.name}}</v-list-item-title>
                                                        </v-list-item> 
                                                    </div> 
                                                </v-list> 
                                                <v-layout >
                                                    <v-spacer></v-spacer>
                                                    <v-btn @click="menuTableSet = false" color="primary">OK</v-btn>
                                                </v-layout>
                                            </v-card-text>
                                            
                                        </v-card> 
                                    </v-menu>
                                </v-toolbar>
                                <v-card-title>
                                    VISITERS 
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        append-icon="search"
                                        label="Search"
                                        single-line
                                        hide-details
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="headers('visiters')"
                                    :items="joined_visiter"
                                    :search="search" >

                                    <template v-slot:top> 
                                    </template> 

                                    <template v-slot:item.device_icon="{ item }" >  
                                        <v-icon>{{item.device_icon}}</v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                            <v-icon>warning</v-icon>
                                            Empty
                                        </v-layout>
                                    </template>
                                </v-data-table>  
                                
                            </v-card>
                        </v-card-text> 
                        <v-sheet v-else  class=""
                            :height="vsh/2"
                            tile="">
                            <v-layout justify-center="" align-center="" fill-height="">
                                <v-icon class="px-1 pb-1">warning</v-icon>
                                <div>No data Found</div>
                            </v-layout>
                        </v-sheet> 
                    </div>
                </v-card>
            </v-col>  
        </v-layout>
    </v-container> 
    <br>
  </div> 
</template>

<script>
let PAGE_NAME = "VISITERS"
    export default {
        name:PAGE_NAME, 
        props:["not"],
        data() {
            return {
                page_current:1,
                page_size:10,
                page_show:false,  
                menuTableSet:false,
                search:'',  
                xHeaders:[ 
                    {id:1,name:"General",title:true},
                    {id:0,name:"Number",value:"No",show:true},
                    {id:0,name:"Icon",value:"device_icon",show:true},

                    {id:0,name:"os",show:true}, 
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Country",value:"location_country",show:true},  
                    {id:0,name:"City",value:"location_city",show:true},   
                    {id:0,name:"Revisit",value:"total_revisit",show:true}, 
                    {id:0,name:"first Visit",value:"first_visit",show:true}, 
                    {id:0,name:"Last Visit",value:"last_visit",show:true},  
                ],
                images:[
                    {src:require(`@/assets/awrim/group/g4.jpeg`),local:true},  
                ] 

            }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notText:false,
                notIndicators:true,
                notHeight:"350",
                notImages:this.images
            })

            this.FEEDBACKS(1000)
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            },
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            visiters(){
                return this.$store.getters.getVisiters
            },
            visitersSize(){
                return this.visiters?this.visiters.length:0
            },
            p_visiters(){
                if (!this.visiters) {
                    return null
                }
                let list = [...this.visiters]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            },
            joined_visiter(){
                let visiters = this.visiters
                let join = this.not.JOIN_VISITER(visiters)
                return join
            }
        },
        methods: {
            notYesDialog(action){ 
                if (action.code) {
                    if (action.code===PAGE_NAME+":DELETE-MESSAGE") {
                        this.$store.dispatch("fi_delete",{
                            action:"Message",
                            path:"MBS/MESSAGES/"+action.key
                        }) 
                    }
                }  
            },  

            //Headers
            headers(type){
                let hds = null
                if (type === 'visiters') {
                    hds = this.xHeaders
                }else if (type === 'excel'){
                    hds = this.xHeaders
                } 
                let headers = this.not.CREATE_TABLE_HEADER(hds) 
                return headers
            },
            //LOAD
            EXIT_PAGE(){
                if (!this.us) {
                    this.not.notDialog(true,true,'To access the page, you must login first.','','OK','')
                    this.not.go("/login")
                }
            },
            FEEDBACKS(time = 400){ 
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses 
                    this.EXIT_PAGE()
                    if (ps) {
                        let getting = ps.find(process=>{
                            return process.name == 'getting/Messages'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'deleting/Message'
                        })
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/Message'
                        })

                        if (getting) {
                            this.page_show =false  
                        }else{
                            this.page_show =true 
                        } 
                        if (deleting) {
                            this.not.notDialogP(null,true,true,'Deleting...') 
                        }else{  
                        } 

                    }else{
                       this.page_show =true  
                       
                    }

                    //check response
                    if (res.res==='deleting/Message/successful') { 
                        this.not.notDialog(true,true,'Successful','Message, successfully deleted.','','OK','') 
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/Message/error'){
                        this.formRes() 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting message.','','OK','') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },time)
            }
        },
        watch: {
            us(v){
                this.EXIT_PAGE()
            },
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            } 
        },
  }
</script>
 
